

export interface IHistogeneticsRequest {
    id: number,
    type: string,
    donorAlias: string,
    recipientAlias: string,
    donorFirstName: string,
    donorLastName: string,
    voucherFirstName: string,
    voucherLastName: string,
    resultsDateTime: string
    orderDateTime: string
    uploadDate: string
    shipBackDate: string
}